
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ORDER_SUMMARY"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Basket"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderTotal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shippingTotalTax"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shippingTotal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"productTotal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"productSubTotal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"taxTotal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pointsToRedeem"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"c_couponTotal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"c_promotionTotal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"c_giftPrice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"c_giftDiscount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"c_totalSavings"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"c_giftMessage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"c_productTotalWithOutGift"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"c_earnPlaceCashAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"c_earnPlaceCashCoupon"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"c_earnPlaceProximity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"c_taxIdentifierAttribute"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"c_cartTotalAfterPLCCDiscount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"c_bopisIntlField"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"c_bossIntlField"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"airMiles"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shippingItems"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceAdjustments"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"couponCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"promotionId"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderPriceAdjustments"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appliedDiscount"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"itemText"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"price"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"couponCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"promotionId"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":918}};
    doc.loc.source = {"body":"fragment ORDER_SUMMARY on Basket {\n  orderTotal\n  shippingTotalTax\n  shippingTotal\n  productTotal\n  productSubTotal\n  taxTotal\n  pointsToRedeem\n  c_couponTotal\n  c_promotionTotal\n  c_giftPrice\n  c_giftDiscount\n  c_totalSavings\n  c_giftMessage\n  c_productTotalWithOutGift\n  c_earnPlaceCashAmount\n  c_earnPlaceCashCoupon\n  c_earnPlaceProximity\n  c_taxIdentifierAttribute\n  c_cartTotalAfterPLCCDiscount\n  c_bopisIntlField\n  c_bossIntlField\n  airMiles\n  shippingItems {\n    priceAdjustments {\n      couponCode\n      promotionId\n    }\n  }\n  orderPriceAdjustments {\n    appliedDiscount {\n      amount\n    }\n    itemText\n    price\n    couponCode\n    promotionId\n  }\n  # SFCC-TODO to remove in future\n  # lastModified\n  # adjustedMerchandizeTotalTax\n  # adjustedShippingTotalTax\n  # agentBasket\n  # channelType\n  # creationDate\n  # currency\n  # inventoryReservationExpiry\n  # merchandizeTotalTax\n  # taxation\n  # sourceCode\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["ORDER_SUMMARY"] = oneQuery(doc, "ORDER_SUMMARY");
        
